import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicBoxQuestionnaireContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeFilled!: boolean;
}
